import React from "react";
import cs from "classnames";

import { Icon } from "../../../Icon/Icon";
import { IconDefinition } from "../../../Icon/Icon.generated";

import "./ui.scss";

interface Props {
  title: React.ReactNode;
  icon?: IconDefinition;
  className?: string;
}

export const SectionHeader = ({ title, icon, className }: Props) => (
  <div className={cs("SectionHeader", className)}>
    {icon && (
      <div className="SectionHeader__icon" aria-hidden="true">
        <Icon icon={icon} />
      </div>
    )}
    <h3 className="SectionHeader__title">{title}</h3>
  </div>
);
